import { generateDefaultData as generateTextData } from 'widgets/TextBasedWidgets/TextWidget/TextWidget.helpers';
import { NewWidget } from 'widgets/Widget.types';

/**
 * Toggle Accordion expanded panel.
 *
 * @param indexes Initial or current expanded accordion indexes
 * @param valueToAdd New expanded panel
 * @returns {number[]} ExpandedIndexes
 */
export const toggleAccordionExpand = (indexes: number[], valueToAdd: number): number[] => {
  const index = indexes.indexOf(valueToAdd);
  if (index > -1) {
    const copy = [...indexes];
    copy.splice(index, 1);
    return copy;
  } else {
    return [...indexes, valueToAdd];
  }
};

export const generateNewWidgetMember = () => {
  return generateTextData() as NewWidget;
};

/**
 * Update correct answers order
 * @param correctAnswers {string[]} Correct answers
 * @param indexToRemove {number} Index to remove
 * @returns {string[]} Updated correct answers
 */
export const updateCorrectAnswers = (correctAnswers: string[], removeIndex: number): string[] => {
  if (removeIndex < 0 || !correctAnswers.length) return correctAnswers;

  return Array.from(correctAnswers)
    .filter((value) => value !== removeIndex.toString())
    .map((value) => {
      if (removeIndex < parseInt(value)) {
        return (parseInt(value) - 1).toString();
      } else return value;
    });
};
